import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useContent } from "@/lib/content";
import { LOGO_CIRCLE } from "@/theme/tokens";

const Footer = () => {
  const { siteContent } = useContent();
  const year = new Date().getFullYear();
  const { contact, footer } = siteContent;
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 mt-10"
      style={{
        background: "rgba(0,0,0,0.65)",
        borderTop: "1px solid rgba(255,255,255,0.10)",
        backdropFilter: "blur(10px)",
      }}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={LOGO_CIRCLE}
              alt="Glitch Game Labs"
              className="w-10 h-10 rounded-full object-cover"
              style={{ background: "#fff" }}
            />
            <span
              className="font-black text-sm tracking-[0.3em] uppercase text-white"
              style={{ fontFamily: "'Azeret Mono', monospace" }}
            >
              Glitch<span style={{ color: "#c8ff2a" }}>/</span>Game Labs
            </span>
          </div>
          <p className="text-sm leading-relaxed text-white/60 max-w-sm">
            Casual &amp; arcade game development studio. Client work, original
            IP and Unity Asset Store tools.
          </p>
        </div>

        {/* Contact */}
        <div className="md:col-span-7 md:ml-auto">
          <div className="text-[10px] tracking-[0.32em] uppercase text-[#ff2a8f] font-bold mb-4">
            Reach us
          </div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-3">
              <MapPin size={15} className="mt-0.5 text-[#2ad6ff] shrink-0" />
              <span
                dangerouslySetInnerHTML={{
                  __html: contact?.address || "",
                }}
              />
            </li>
            {contact?.phone && (
              <li className="flex gap-3 items-center">
                <Phone size={15} className="text-[#c8ff2a] shrink-0" />
                <a
                  href={`tel:${contact.phone.replace(/\s/g, "")}`}
                  className="hover:text-[#c8ff2a]"
                >
                  {contact.phone}
                </a>
              </li>
            )}
            {contact?.email && (
              <li className="flex gap-3 items-center">
                <Mail size={15} className="text-[#ff2a8f] shrink-0" />
                <a
                  href={`mailto:${contact.email}`}
                  className="hover:text-[#ff2a8f] break-all"
                >
                  {contact.email}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div
        className="border-t border-white/10 py-5 text-[10px] tracking-[0.32em] uppercase text-white/40 text-center"
        style={{ fontFamily: "'JetBrains Mono', monospace" }}
      >
        © {year} {footer?.text || "Glitch Game Labs."}
      </div>
    </footer>
  );
};

export default Footer;
